import { Grid, Typography } from '@mui/material';

interface Props {
  label: string;
  value?: string | null;
  size?: any;
  /** Amostra de cor à esquerda do valor, nos campos de cor. */
  swatch?: boolean;
}

/** Par rótulo/valor no mesmo formato do Show do desconto. */
const ReadOnlyValue = ({ label, value, size = 12, swatch }: Props) => (
  <Grid size={size}>
    <Typography variant="caption" color="text.secondary" display="block">{label}</Typography>
    <Typography
      variant="body1"
      fontWeight={600}
      sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
    >
      {swatch && value && (
        <Typography
          component="span"
          sx={{
            width: 16, height: 16, borderRadius: 0.5, backgroundColor: value,
            border: '1px solid', borderColor: 'divider', flexShrink: 0,
          }}
        />
      )}
      {value || '—'}
    </Typography>
  </Grid>
);

export default ReadOnlyValue;
